import React from 'react';
import styled from 'styled-components';
import { graphql, useStaticQuery } from 'gatsby';
import _map from 'lodash/map';
import SEO from '../components/SEO';
import FeaturedBlogs from '../containers/FeaturedBlogs';
import SuccessStories from '../containers/SuccessStories';
import InsightVideos from '../containers/InsightVideos';

const BlogPageWrapper = styled.article``;

const blogQuery = graphql`
  {
    page: datoCmsBlogPage {
      title
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
    }
    posts: allDatoCmsBlogPost(
      sort: { fields: [meta___updatedAt], order: DESC }
    ) {
      edges {
        node {
          id
          title
          shortDescription
          meta {
            updatedAt
            createdAt
          }
          featuredImage {
            sizes(maxWidth: 500) {
              src
              srcSet
            }
          }
          slug
        }
      }
    }
    stories: allDatoCmsStudentSuccess(
      sort: { fields: [meta___updatedAt], order: ASC }
    ) {
      edges {
        node {
          id
          title
          shortDescription
          meta {
            updatedAt
            updatedAt
          }
          featuredImage {
            sizes(maxWidth: 500) {
              src
              srcSet
            }
          }
          slug
        }
      }
    }

    videos: allDatoCmsVideoPost(sort: { fields: position }) {
      edges {
        node {
          youtubeVideoId
          coverPhoto {
            sizes(maxWidth: 500) {
              src
            }
          }
        }
      }
    }
  }
`;

export default function Blog() {
  const data = useStaticQuery(blogQuery);
  const { title, seoMetaTags } = data.page;
  const { posts, stories, videos } = data;

  return (
    <BlogPageWrapper>
      <SEO meta={seoMetaTags} />
      <SuccessStories posts={stories.edges} style={{ paddingTop: '120px' }} />
      <InsightVideos posts={videos.edges} />
      <FeaturedBlogs posts={posts.edges} style={{ paddingTop: '60px' }} />
    </BlogPageWrapper>
  );
}
